import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Notice: The Vidstack library implements a similar component for handling (Gesture) the same feature, but it
 * only works when clicking on the MediaProvider area, so wouldn't work with multiple videos. This simple implementation
 * does the trick.
 */
import { useMediaRemote } from "@vidstack/react";
import { useState } from "react";
const Gestures = () => {
    const [timerId, setTimerId] = useState(null);
    const remote = useMediaRemote();
    const handleClick = () => {
        if (timerId)
            return;
        const timer = window.setTimeout(() => {
            if (timerId)
                window.clearTimeout(timerId);
            remote.togglePaused();
            setTimerId(null);
        }, 200);
        setTimerId(timer);
    };
    const handleDoubleClick = () => {
        if (timerId !== null) {
            clearTimeout(timerId);
            setTimerId(null);
        }
        remote.toggleFullscreen();
    };
    // biome-ignore lint/a11y/useKeyWithClickEvents: <explanation>
    return _jsx("div", { "data-testid": "gestures-video-player", className: "absolute inset-0 z-0 block h-full w-full", onClick: handleClick, onDoubleClick: handleDoubleClick });
};
Gestures.displayName = "Gestures";
export default Gestures;
